<style>
.center {
  margin: 20px 0 0 20px;
}
</style>

<template>
  <div class="app-container">
    <ut-form inline class="center">
      <ut-form-item label="业务异常监控Key" index="git">
        <ut-input v-model="alarmKey"></ut-input>
      </ut-form-item>

      <ut-form-item>
        <ut-button type="primary" @click="search">查询</ut-button>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="goAdd">添加</ut-button>
      </ut-form-item>
    </ut-form>

    <ut-table :source="dataSource" border>
      <ut-table-column title="业务异常监控Key" key="alarmKey" index="alarmKey"/>
      <ut-table-column title="报警策略名称" key="alarmPolicyName" index="alarmPolicyName"/>
      <ut-table-column title="创建时间" key="created" index="created"/>
      <ut-table-column title="创建账户" key="creater" index="creater"/>
      <ut-table-column title="更新时间" key="updated" index="updated"/>
      <ut-table-column title="更新账户" key="updater" index="updater"/>
      <ut-table-column title="操作" inline-template>
        <div>
          <ut-button type="info" size="small" @click.native="update($index,row)" :style="{marginLeft:'5px'}">修改</ut-button>
          <ut-popconfirm @confirm="deleteRow($index,row)" title="你确定要删除本行么？">
            <ut-button type="danger" size="small" :style="{marginLeft:'5px'}">删除</ut-button>
          </ut-popconfirm>
          <ut-button type="success" size="small" @click.native="copy($index,row)" :style="{marginLeft:'5px'}">复制</ut-button>
        </div>
      </ut-table-column>
    </ut-table>
    <ut-pagination
      :style="{ marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '20px' }"
      :total="pageInfo.totalCount"
      :current="pageNo"
      @change="changePager"
      :page-size="20"
    ></ut-pagination>
  </div>
</template>

<script lang="babel">
export default {
  data() {
    return {
      alarmKey:'',
      pageInfo: {
        totalCount: 0
      },
      pageNo: 1,
      dataSource: []
    };
  },
  methods: {
    copy(idx,row){
      var json = {
        path : "/bizs/copy",
        query : {
          id: row.id
        }
      }
      this.$router.push(json);
    },
    goAdd() {
      this.$router.push({ path: "/bizs/add" });
    },
    update(idx,row){
      var json = {
        path : "/bizs/edit",
        query : {
          id: row.id
        }
      }
      this.$router.push(json);
    },
    deleteRow(idx, row) {
      console.log("delete this.dataSource.length idx ["+this.dataSource.length+"] row ["+idx+"]")
      if(this.dataSource.length == 1 && this.pageNo != undefined){
        this.pageNo = 0;
        this.pageInfo.totalCount = 1;
      }
      this.$http({
        method: "post",
        url: "bizs/" + row.id + "/remove.htm"
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          var sendData = {}

          if(this.selected1 != undefined && this.selected1 != ""){
            sendData.level = this.selected1;
          }
          if(this.appId != ""){
            sendData.appId = this.appId;
          }
          if(this.appName != ""){
            sendData.appName = this.appName;
          }
          if(this.pageNo == undefined){
            sendData.pageNo = 0;
          }else{
            sendData.pageNo = this.pageNo;
          }

          console.log(sendData)
          var sendJson = JSON.stringify(sendData);

          this.$http({
            method: "post",
            url: "bizs/query.htm",
            data: sendJson
          })
            .then(response => {
              //这里使用了ES6的语法
              console.log(response); //请求成功返回的数据
              this.dataSource = response.data.dataList;
            })
            .catch(error => {
              console.log(error); //请求失败返回的数据
            });
            })
            .catch(error => {
              console.log(error); //请求失败返回的数据
            });
    },
    formatLevel(level) {
      switch (level) {
        case 0: {
          return "2";
        }
        case 1: {
          return "primary";
        }
        case 2: {
          return "success";
        }
        case 3: {
          return "warning";
        }
        case 4: {
          return "danger";
        }
      }
    },
    changePager(page) {

      var sendData = {}
      if(page == 0){
        return false;
      }
      if(this.alarmKey != undefined && this.alarmKey != ""){
        sendData.alarmKey = this.alarmKey;
      }
      sendData.pageNo = page;

      console.log(sendData)
      var sendJson = JSON.stringify(sendData);

      this.$http({
        method: "post",
        url: "bizs/query.htm",
        data: sendJson
      })
        .then(response => {
          this.$message.info(`当前切换到第${page}页`);
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          this.pageNo = page;
          this.dataSource = response.data.dataList;
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    search(){
      var sendData = {}

      if(this.alarmKey != undefined && this.alarmKey != ""){
        sendData.alarmKey = this.alarmKey;
      }

      console.log(sendData)
      var sendJson = JSON.stringify(sendData);
      console.log(sendJson)
      this.$http({
      method: "post",
      url: "bizs/query.htm",
      data: sendJson
    })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response); //请求成功返回的数据
        this.dataSource = response.data.dataList;
        this.pageInfo.totalCount = response.data.totalCount;
        this.pageNo = response.data.totalPageCount > 0 ? 1:0;
        this.$message.info(`当前切换到第${this.pageNo}页`);
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });
    }
  },
  created() {
    this.$http({
      method: "post",
      url: "bizs/query.htm",
      data: "{}"
    })
      .then(response => {
         if(response === undefined){
          console.log("没有返回数据");
          this.$message.info(`系统异常跳回登录`);
          this.$router.push({ path: "/login" });
        }
        this.dataSource = response.data.dataList;
        this.pageInfo.totalCount = response.data.totalCount;
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });
  },
  filters: {
    setStr(s) {
      return s.owners.map(item => item.name).join(",");
    }
  }
};
</script>
